import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import * as _ from "../util/lodash";
var animations = {
  SLIDE_RIGHT: 'slide right',
  SLIDE_LEFT: 'slide left',
  SLIDE_DOWN: 'slide down'
};
animations.ALL = _valuesInstanceProperty(_).call(_, animations);
export default animations;
//# sourceMappingURL=animations.js.map